import { Injectable, inject, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { select, Store } from '@ngxs/store';
import { TenantState } from './state/tenant.state';
import { LoadTenants } from './state/tenant.action';

@Injectable()
export class TenantResolver {
  private readonly injector = inject(Injector);

  private tenantsLoaded = select(TenantState.tenantsLoaded);

  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return toObservable(this.tenantsLoaded, { injector: this.injector }).pipe(
      tap((tenantsLoaded) => {
        if (!tenantsLoaded) {
          this.store.dispatch(new LoadTenants());
        }
      }),
      filter((tenantsLoaded) => tenantsLoaded),
      first()
    );
  }
}
